import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { brandColors } from '../../constants/brandColors';

/**
 * WhatsAppBubble — balão de mensagem no estilo WhatsApp, dentro de um painel
 * que imita o fundo do app. Reutilizado na pré-visualização (config) e no
 * exemplo do hero (estado desativado).
 */
export default function WhatsAppBubble({ text, sx }) {
  return (
    <Box
      sx={{
        bgcolor: '#efeae2',           // fundo do chat do WhatsApp
        borderRadius: 2,
        p: 1.5,
        ...sx,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          maxWidth: '94%',
          bgcolor: brandColors.whatsapp.bubble,
          borderRadius: 1.5,
          borderTopLeftRadius: 2,
          px: 1.75,
          py: 1.25,
          whiteSpace: 'pre-line',
          fontSize: 13.5,
          lineHeight: 1.55,
          color: 'rgba(0,0,0,0.82)',
          boxShadow: '0 1px 1.5px rgba(0,0,0,0.15)',
        }}
      >
        {text}
      </Box>
    </Box>
  );
}

WhatsAppBubble.propTypes = {
  text: PropTypes.string,
  sx: PropTypes.object,
};
